import { RateLimiterOptions } from "~/modules/ratelimiter";

export type TelemetryRateLimiterOptions = Omit<RateLimiterOptions, "name">;

export const telemetryRateLimiterOptions: TelemetryRateLimiterOptions = {
    timeWindow: 60000,
    maxHitsInTimeWindow: 100,
    disableFeatureThreshold: 5
};
